module.exports = __webpack_public_path__ + "img/sdg_es_(12).3bf41edc.png";